module.exports = __webpack_public_path__ + "img/Background-Calendars-2366x901-2021.eb013f48.jpeg";